module.exports = __webpack_public_path__ + "static/img/eye.a18f1b79.svg";